import React,{Component} from 'react';
import Well from "@react/react-spectrum/Well";
import Tooltip from "@react/react-spectrum/Tooltip";
import OverlayTrigger from "@react/react-spectrum/OverlayTrigger";
import Info from "@react/react-spectrum/Icon/Info";
import {Grid,GridRow,GridColumn} from '@react/react-spectrum/Grid';
import {Asset} from '@react/react-spectrum/Asset';
import ApproveModal from '../Modal/ApproveModal';
import _ from 'lodash';
import i18n from '../../i18n';
import RejectModal from "../Modal/RejectModal";
import {withTranslation } from 'react-i18next';
import NoRecords from "../Common/NoRecords";
import Loader from "../Common/Loader";
import ApprovalHeader from '../approval-header/ApprovalHeader';
import {AccordionWithHeader, AccordionNode, AccordionHeader, AccordionPanel} from 'react-accordion-with-header';
import * as appConstants from '../../constants/AppConstants';
import ChevronRight from '@react/react-spectrum/Icon/ChevronRight';
import ChevronDown from '@react/react-spectrum/Icon/ChevronDown';
import {connect} from "react-redux";
import Search from '@react/react-spectrum/Search';
import {refreshApprovalList} from "../../actions/ApprovalListActions";
import Refresh from '@react/react-spectrum/Icon/Refresh';
import Clock from '@react/react-spectrum/Icon/Clock';
import Disclaimer from '../Banner/Disclaimer';
import ApprovalService from "../../services/ApprovalService";
import {setFeatureFlag} from "../../actions/AppActions";
import moment from "moment";


export class ApprovalComponent extends Component{
    constructor(props){
        super(props);
        this.state = {
            selectedWorkFlowID:'',
            selectedWorkFlowDetails:[],
            apiStatus:'',
            currentPanelStatus:[],
            approvalList:this.props.approvalList,
            isSearchEnabled : false,
            searchedText : ""
        };
        this.getAccordianPanelStatus = this.getAccordianPanelStatus.bind(this);
        this.searchApprovals = this.searchApprovals.bind(this);
        this.refreshApprovalList = this.refreshApprovalList.bind(this);
        this.backToApprovalList = this.backToApprovalList.bind(this);
        this.getFeatureFlags = this.getFeatureFlags.bind(this);
        this.formatDateSafely = this.formatDateSafely.bind(this);
        this.parseAndValidateDate = this.parseAndValidateDate.bind(this);
        this.getApprovalColumnValueByKey = this.getApprovalColumnValueByKey.bind(this);
        this.renderPrimaryAdminChangeMessage = this.renderPrimaryAdminChangeMessage.bind(this);
    }

    componentDidMount() {
        this.getFeatureFlags();
    }

    accordianActionCallback(panels){
        this.setState({currentPanelStatus:panels});
    }

    getAccordianPanelStatus(index){
        if(!_.isUndefined(this.state.currentPanelStatus) && this.state.currentPanelStatus.length){
            let currentSelectedPanel = _.filter(this.state.currentPanelStatus, function(statusObj) {
                return statusObj.panel === index;
            });
            return (currentSelectedPanel[0]) ? currentSelectedPanel[0].open :  '';
        }else{
            return (index === 0);
        }
    }

    searchApprovals(searchText){
        this.setState({searchedText: searchText});
        if(!_.isEmpty(searchText)){
            this.setState({isSearchEnabled:true});
            let filteredApprovalList = _.filter(this.props.approvalList, function (obj) {
                let objJson = JSON.stringify(obj);
                if(_.includes(objJson.toLowerCase(),searchText.toLowerCase()))
                    return obj;
            });
            this.setState({approvalList:filteredApprovalList});            
        }
        else{
            this.setState({isSearchEnabled:false});
            this.setState({approvalList:this.props.approvalList});   
        }
    }

    refreshApprovalList(){
        var _self = this;
        this.props.refreshApprovalList(_self.props.workFlowId,this.props.context,this.props.customerGuid,this.props.approvalId);
    }
    backToApprovalList(){
        if(this.props.history){
            this.props.history.push('/');
        }
    }

    getFeatureFlags() {
        ApprovalService.loadFeatureFlag().then(response =>{
            const featureFlag = response.data;
            if(featureFlag.releases && (featureFlag.releases.length > 0) && (featureFlag.releases[0].features)){
                this.props.setFeatureFlag(featureFlag.releases[0].features);
            }
            
        },
        function(error){   
           console.log("ERROR",error);
        });             
    }


    renderImages(product, productKey) {
        return (
            <div className={`product-image ${product[productKey].iconUrl && product[productKey].iconUrl.includes('apple_pay_border') ? 'apple-pay-icon': ''}`} data-am-id="productImage">
                {product[productKey].iconUrl ? (
                    <Asset type="image" src={product[productKey].iconUrl} alt="Product"/>
                ) : (
                        <Asset type="image" src="" alt="Product"/>
                    )}

            </div>
        )

    }
    getPaymentInfo = (type,product,productKey) =>{
        let payment = {};
        switch (type) {
            case appConstants.CREDIT_CARD:
                payment = {
                    type: product[productKey].value.split("|")[0],
                    ccNumber: product[productKey].value.split("|")[1],
                    date: product[productKey].value.split("|")[2]
                }
            break;
            case appConstants.PURCHASE_ORDER:
                payment = {
                   value:  product[productKey].value
                }
            break;
            case appConstants.DIRECT_DEBIT:
                payment = {
                    value:  product[productKey].value
                }
            break;
            case appConstants.PAYPAL:
                payment = {
                    value:  product[productKey].value
                }
            break;  
            case appConstants.KLARNA:
                payment = {
                    value: product[productKey].value
                }
                break;
            case appConstants.EXTERNAL_WALLET:
                payment = {
                    value: product[productKey].value,
                    type: product[productKey].paymentType && product[productKey].paymentType.replace(/_/g, ' ')
                }
            break;
            case appConstants.LPM:
                payment = {
                    value:  product[productKey].value,
                    type: product[productKey].paymentType && product[productKey].paymentType.replace(/_/g, ' ')
                }
            break;          
            default:
            break;
        }
        return payment;
    }
    getCurrentPaymentType = (product) => {
        let type = "";
        if(product['column2'].key === 'Payment Type'){
            type = product['column2'].value;
        }
        return type;
    }
    parseAndValidateDate(dateString) {
        if (!dateString) return null;

        // Try parsing with moment
        const parsedDate = moment(dateString);
        if (parsedDate.isValid()) {
        return parsedDate;
        }
        return null;
    }
    formatDateSafely(date, formatStr) {
        if (!date) return "";
        try {
        return moment(date).format(formatStr);
        } catch (error) {
        return "";
        }
    }
    renderValues(product, productKey, obj) {
        if (product[productKey].key === 'Payment Type') {
            const paymentType = this.getCurrentPaymentType(product);
            const payment = this.getPaymentInfo(paymentType, product, productKey);
            return (<div className="accordion-item-value">
                {i18n.t(this.props.workFlowId + '.approvalDetails.approvalItems.row0.' + productKey + '.' + product[productKey].value, { payment })}
            </div>)
        }
        if(product[productKey].key === 'Payment Information'){
            const paymentType = this.getCurrentPaymentType(product);
            const payment = this.getPaymentInfo(paymentType,product,productKey);
            if (paymentType !== appConstants.EXTERNAL_WALLET) {
                return (<div className="accordion-item-value">
                    {i18n.t(this.props.workFlowId + '.approvalDetails.approvalItems.row0.' + productKey + '.' + paymentType + '.value', { payment })}
                </div>)
            } else {
                if (payment && payment.type && appConstants.LPM_PAYMENT_LIST_FOR_EMAIL_PHONE.indexOf(payment.type) !== -1) {
                    return (<div className="accordion-item-value">
                        {i18n.t(this.props.workFlowId + '.approvalDetails.approvalItems.row0.' + productKey + '.' + paymentType + '.emailPhone', { payment })}
                    </div>)
                } else if (payment && payment.type && appConstants.LPM_PAYMENT_LIST_FOR_PHONE_NUMBER.indexOf(payment.type) !== -1) {
                    return (<div className="accordion-item-value">
                        {i18n.t(this.props.workFlowId + '.approvalDetails.approvalItems.row0.' + productKey + '.' + paymentType + '.phoneNumber', { payment })}
                    </div>)
                } else if (payment && payment.type && payment.type === appConstants.NUPAY_PAYMENT) {
                    return (<div className="accordion-item-value">
                        {i18n.t(this.props.workFlowId + '.approvalDetails.approvalItems.row0.' + productKey + '.' + paymentType + '.nupayAccount', { payment })}
                    </div>)
                }
                else {
                    return (<div className="accordion-item-value">
                        {i18n.t(this.props.workFlowId + '.approvalDetails.approvalItems.row0.' + productKey + '.' + paymentType + '.value', { payment })}
                    </div>)
                }
            }
        }
        if(product[productKey].key === 'Commitment (Billing)'){
            return (<div className="accordion-item-value">{product[productKey].value}</div>)
        }
        if (product[productKey].key === "ABM_TEXT") {
            // Constants for maintainability
            const CANCELLATION_DAYS = 14;
            const CANCELLATION_DAYS_FOR_TRIAL = 13;
            const DATE_FORMAT = "DD MMMM YYYY";

            try {
                // Safely access nested request body
                const requestBody = _.has(obj, "callBackDetails.requestBody.requestBody")
                    ? obj.callBackDetails.requestBody.requestBody
                    : _.has(obj, "callBackDetails.requestBody.apiDetails.commerce-order-v4-place-order.requestBody")
                    ? obj.callBackDetails.requestBody.apiDetails["commerce-order-v4-place-order"].requestBody
                    : {};

                // Extract date fields with safe checks
                const concessionEndDate =
                requestBody["order-price"] &&
                requestBody["order-price"]["concession-end-date"]
                    ? requestBody["order-price"]["concession-end-date"]
                    : null;

                const trialDiscountWithoutTax =
                    requestBody["order-price"] &&
                    requestBody["order-price"]["trial-discount"] &&
                    requestBody["order-price"]["trial-discount"][
                      "discounts-total-without-tax"
                    ]
                      ? requestBody["order-price"]["trial-discount"][
                          "discounts-total-without-tax"
                        ]
                      : 0;

                const lastModifiedDate =
                requestBody["order-metadata"] &&
                requestBody["order-metadata"]["last-modified-date"]
                    ? requestBody["order-metadata"]["last-modified-date"]
                    : null;

                // Determine if this is a trial or promo offer
                const isTrialOrPromoOffer = !!concessionEndDate && trialDiscountWithoutTax > 0;

                // Use appropriate billing start date
                const billingStartDate = isTrialOrPromoOffer
                ? concessionEndDate
                : lastModifiedDate;

                // Validate billing start date
                const parsedBillingStartDate =
                typeof this.parseAndValidateDate === "function"
                    ? this.parseAndValidateDate(billingStartDate)
                    : null;

                if (!parsedBillingStartDate) {
                // Handle missing or invalid billing start date
                return (
                    <div className="accordion-item-value-abm-info">
                    <Well
                        margin="size-100"
                        UNSAFE_style={{
                        margin: "0 auto",
                        maxWidth: 600,
                        width: "100%",
                        textAlign: "center",
                        }}
                    >
                        <span style={{ color: "red", fontWeight: "bold" }}>
                        {i18n.t('startTimeInvalid')}
                        </span>
                    </Well>
                    </div>
                );
                }

                // Calculate cancellation date
                const billingStartDateWith14Days = moment(parsedBillingStartDate).add(
                isTrialOrPromoOffer ? CANCELLATION_DAYS_FOR_TRIAL : CANCELLATION_DAYS,
                "days"
                );

                const formattedDate =
                typeof this.formatDateSafely === "function"
                    ? this.formatDateSafely(billingStartDateWith14Days, DATE_FORMAT)
                    : "";

                // Construct info text
                const infoText = isTrialOrPromoOffer
                ? i18n.t('trial14Days')
                : i18n.t('toolTipFirstPart') +" " +
                    formattedDate +
                    ", " + i18n.t('toolTipSecondPart');

                return (
                <div className="accordion-item-value-abm-info">
                    <Well
                    margin="size-100"
                    UNSAFE_style={{
                        margin: "0 auto",
                        maxWidth: 600,
                        width: "100%",
                        textAlign: "center",
                    }}
                    >
                    {i18n.t('abmFeeMessage')} <span style={{ fontWeight: "bold" }}>{formattedDate}</span>
                    <OverlayTrigger placement="top">
                        <span
                        style={{
                            display: "inline-block",
                            marginLeft: 4,
                            verticalAlign: "middle",
                        }}
                        >
                        <Info size="S" />
                        </span>
                        <Tooltip variant="info">{infoText}</Tooltip>
                    </OverlayTrigger>
                    </Well>
                </div>
                );
            } catch (error) {
                return (
                <div className="accordion-item-value-abm-info">
                    <Well
                    margin="size-100"
                    UNSAFE_style={{
                        margin: "0 auto",
                        maxWidth: 600,
                        width: "100%",
                        textAlign: "center",
                    }}
                    >
                    <span style={{ color: "red", fontWeight: "bold" }}>
                        {i18n.t('failureDate')}
                    </span>
                    </Well>
                </div>
                );
            }
    }
        else{
            return (<div className="accordion-item-value">{product[productKey].value}</div>)
        }
    }

    getApprovalColumnValueByKey(approvalObj, columnKey) {
        const approvalItems = _.get(approvalObj, 'dataToDisplay.approvalDetails.approvalItems', []);
        if (!approvalItems.length) {
            return '';
        }

        const details = approvalItems[0].details || [];
        for (let detailIndex = 0; detailIndex < details.length; detailIndex++) {
            const row = details[detailIndex];
            const columnKeys = Object.keys(row);
            for (let columnIndex = 0; columnIndex < columnKeys.length; columnIndex++) {
                const column = row[columnKeys[columnIndex]];
                if (column && column.key === columnKey && column.value) {
                    return column.value;
                }
            }
        }

        return '';
    }

    renderPrimaryAdminChangeMessage(approvalObj) {
        const currentPrimaryAdmin = this.getApprovalColumnValueByKey(approvalObj, 'Current Primary Admin');
        const proposedPrimaryAdmin = this.getApprovalColumnValueByKey(approvalObj, 'Proposed Primary Admin');

        return (
            <div className="accordion-item primary-admin-change-message" data-am-id="primaryAdminChangeMessage">
                <p className="accordion-item-value">
                    {i18n.t(this.props.workFlowId + '.approvalDetails.adminChangeMessage', {
                        currentPrimaryAdmin,
                        proposedPrimaryAdmin
                    })}
                </p>
            </div>
        );
    }

    renderDueNowPriceInfo(obj) {
        let totalLicenses = obj.dataToDisplay.priceDueNowInfo.totalLicenses;
        let currencyCode = obj.dataToDisplay.priceDueNowInfo.currencyCode;
        let dueNowAmountWithTax = obj.dataToDisplay.priceDueNowInfo.dueNowAmountWithTax;
        let provisioned_sub_total_with_tax =  obj.dataToDisplay.priceDueNowInfo.provisioned_sub_total_with_tax;
        let sub_total_next_billing_with_tax = obj.dataToDisplay.priceDueNowInfo.sub_total_next_billing_with_tax;
        let total = obj.dataToDisplay.priceDueNowInfo.total;
        let billing_period_start = obj.dataToDisplay.priceDueNowInfo.billing_period_start;

        return (
            <div style={{padding:'10px 20px'}}>
                <div style={{marginBottom:'5px'}}>
                    <span>
                        {' '}
                        <Clock size="S" style={{verticalAlign:'bottom'}}/> &nbsp;
                        {i18n.t(this.props.workFlowId+'.approvalDueNowBanner.Heading')}
                        
                    </span>
                </div>
                <div dangerouslySetInnerHTML={{
                    __html: i18n.t(this.props.workFlowId + '.approvalDueNowBanner.description', {
                        totalLicenses: totalLicenses,
                        currencyCode: currencyCode,
                        dueNowAmountWithTax: dueNowAmountWithTax,
                        provisioned_sub_total_with_tax: provisioned_sub_total_with_tax,
                        sub_total_next_billing_with_tax: sub_total_next_billing_with_tax,
                        total: total,
                        billing_period_start: billing_period_start
                    })
                }}/>
            </div>
        )

    }

    render(){

        let workFlowList = '';
        let currentLocalLanguage = localStorage.userLang;
        if(!_.isUndefined(this.state.approvalList) && this.state.approvalList.length){
            workFlowList = this.state.approvalList.map((obj,objIndex) => {
            let countryCode = '';
            countryCode = obj.approvalMetaData && (obj.approvalMetaData.countryCode) ? obj.approvalMetaData.countryCode : '';
            return(
                <AccordionNode  key={objIndex} className="accordian-header">
                <AccordionHeader data-am-id="approvalHeader">
                    {(this.getAccordianPanelStatus(objIndex)) ?  <ChevronDown className="accordian-icon"/> : <ChevronRight className="accordian-icon"/>}
                    <ApprovalHeader workFlowId={this.props.workFlowId} approvalObj={obj} locale={this.props.locale}/>
                </AccordionHeader>
                <AccordionPanel>
                    <div className="accordian-content" data-am-id="approvalContent">
                        {this.props.workFlowId === appConstants.CHANGE_PRIMARY_ADMIN ? (
                            this.renderPrimaryAdminChangeMessage(obj)
                        ) : (
                        (obj.dataToDisplay.approvalDetails && obj.dataToDisplay.approvalDetails.approvalItems && obj.dataToDisplay.approvalDetails.approvalItems.length > 0) ?
                            obj.dataToDisplay.approvalDetails.approvalItems.map((approvalItemObj,approvalItemIndex) => {
                            return (
                                <div key={approvalItemIndex} className="accordion-item">
                                    <h4 className="no-margin header-value" data-am-id="approvalContentHeader">{approvalItemObj.header}</h4>
                                    {approvalItemObj.details.map((product,index) => {
                                        return (
                                            <div key={index}>
                                                <Grid variant="fluid">
                                                    <GridRow align={{lg: 'start',md: 'start',sm: 'start',xl: 'start',xs: 'start'}} reverse={false} className="products-info align-center" data-am-id="approvalContentRow" id="product-info-id">
                                                        {Object.keys(product).map((productKey,productIndex) => {
                                                            return(
                                                                <GridColumn size={product[productKey].key === "ABM_TEXT" ?[12,12,12,12]:[12,2,2,2]} key={productIndex}  data-am-id="approvalContentColumn" style={{ maxHeight: '200px', alignSelf: 'flex-start' }}>
                                                                    {product[productKey].isIcon ? (
                                                                        <div>
                                                                            {this.renderImages(product, productKey)}
                                                                        </div>
                                                                    ):(((product[productKey].isPrice && product[productKey].value) || (!product[productKey].isPrice )) ? (
                                                                        <div data-am-id="columnInfo">
                                                                            {((!obj.approvalMetaData.enableDueNowHeading) && (!obj.approvalMetaData.enableDueNowPrice)) && (<label>{i18n.t(this.props.workFlowId+'.approvalDetails.approvalItems.row'+approvalItemIndex+'.'+productKey+'.key')}</label>)}
                                                                            {obj.approvalMetaData.enableDueNowHeading && (<label>{i18n.t(this.props.workFlowId+'.approvalDetails.approvalItemsDueNow.row'+approvalItemIndex+'.'+productKey+'.key')}</label>)}
                                                                            {obj.approvalMetaData.enableDueNowPrice && !obj.approvalMetaData.enableDueNowHeading && (<label>{i18n.t(this.props.workFlowId+'.approvalDetails.approvalItemsDueNowTaxInfo.row'+approvalItemIndex+'.'+productKey+'.key')}</label>)}
                                                                            {
                                                                                (product[productKey].isPrice && product[productKey].value) ? (<div className="accordion-item-value">
                                                                                {  ApprovalService.decimalFilterForCountry(currentLocalLanguage, product[productKey].value.toString().split('|')[0],countryCode)
                                                                                }
                                                                                 {product[productKey].value.toString().split('|')[1] && (' ' + product[productKey].value.toString().split('|')[1])}
                                                                            </div>) : (<div>{this.renderValues(product, productKey,obj)}</div>)
                                                                            }
                                                                        </div>
                                                                    ):('')
                                                                    )}
                                                                </GridColumn>
                                                            )
                                                        })}
                                                    </GridRow>
                                                </Grid>
                                            </div>
                                        )
                                    })}
                                </div>
                            )
                        }) : '')
                        }
                        
                        {obj.approvalMetaData.enableDueNowPrice && !obj.approvalMetaData.enableDueNowHeading && obj.dataToDisplay && obj.dataToDisplay.priceDueNowInfo && obj.flowId !== 'TEAM_CHANGE_PLAN' && this.props.workFlowId !== appConstants.CHANGE_PRIMARY_ADMIN && (
                           this.renderDueNowPriceInfo(obj)
                        )}
                        {(appConstants.DISABLE_ACTION_STATUS.indexOf(obj.status) < 0) ? (
                            <GridRow>
                                <GridColumn>
                                    <div className="action-panel">
                                        <ApproveModal 
                                            approvedData={this.props.approvalList.find((approval) => approval.approvalId === obj.approvalId)} 
                                            btnLabel={i18n.t(this.props.workFlowId+'.approveBtn.btnLabel')} 
                                            variant="cta" 
                                            workFlowType={this.props.workFlowId} 
                                            approvalMetaData={obj.approvalMetaData} 
                                            approveId={obj.approvalId} 
                                            totalLicenses={(obj.dataToDisplay && obj.dataToDisplay.productsInfo && obj.dataToDisplay.productsInfo.totalLicenses) ? obj.dataToDisplay.productsInfo.totalLicenses : 1} 
                                        />
                                        <RejectModal btnLabel={i18n.t(this.props.workFlowId+'.rejectBtn.btnLabel')} variant="warning" workFlowType={this.props.workFlowId} approveId={obj.approvalId}/>
                                    </div>
                                </GridColumn>
                            </GridRow>
                        ):''}
                    </div>
                </AccordionPanel>
            </AccordionNode >
            )});
        }

        let headerSection = '';

        if(this.props.workFlowId){
            headerSection=  (
                <section>
                    <div className="header">
                        <span>{i18n.t(this.props.workFlowId+'.approvalHeaderInfo.title')}</span>
                    </div>
                    <div className="subHeader" id="approval-subheader">
                        {(this.props.workFlowId === 'ADD_LICENSE') ? (<span>{i18n.t(this.props.workFlowId+'.approvalHeaderInfo.description')}</span>) : <span></span>}
                        <div style={{display:'flex',alignItems:'center',marginRight:'15px'}}>
                            { this.props.context === 'APPROVAL_DETAILS' && 
                                <span className="back-to-home-btn" onClick={this.backToApprovalList}>
                                    {i18n.t('backToApprovalListBtnLabel')}
                                </span>
                            }
                            {this.props.context === 'APPROVAL_LIST' && <Search id="input-search-box" placeholder={i18n.t(this.props.workFlowId+'.approvalHeaderInfo.search')} value={this.state.searchedText} onChange={this.searchApprovals} onSubmit={this.searchApprovals} data-am-id="searchApprovalList" className="search-box" />} &nbsp;&nbsp;
                            <div className="refresh-btn" id="approval-refresh-btn" data-am-id="refreshApprovalList" onClick={this.refreshApprovalList}>
                                <Refresh/>
                            </div>
                        </div>

                    </div>
                </section>
            );
        }

        return(
            <div>
                {headerSection}
                <Disclaimer workFlowId={this.props.workFlowId} />
                {(!_.isUndefined(this.state.approvalList) && this.state.approvalList.length) ? (
                    <AccordionWithHeader firstOpen={true} actionCallback={this.accordianActionCallback.bind(this)}>
                        {workFlowList}
                    </AccordionWithHeader>
                ) : ((!_.isUndefined(this.state.approvalList) && this.state.approvalList.length === 0) ? ((this.props.approvalId) ? (<NoRecords message="noRecordsFound" approvalId={this.props.approvalId}/>) : (this.state.isSearchEnabled) ? <NoRecords message="noSearchResultFound"/> : <NoRecords message="noApprovalListMessage"/>) : (<Loader loaderSize="L"/>))}

            </div>

        )
    }
}

const mapStateToProps = (state)=>{
    return{
        workFlowId:state.ApprovalListReducer.selectedTab,
        apiStatus: state.ApprovalListReducer.apiStatus,
        locale:state.LocaleReducer.value,
        approvalList : state.ApprovalListReducer.approvalList,
    }
};

const mapDispatchToProps = (dispatch)=>{
    return{
        refreshApprovalList:(workFlowId,context,customerguid,approvalId)=>{dispatch(refreshApprovalList(workFlowId,context,customerguid,approvalId))},
        setFeatureFlag:(list)=> {dispatch(setFeatureFlag(list))}
    }
};


export default connect(mapStateToProps,mapDispatchToProps)(withTranslation()(ApprovalComponent));



